import { useIsMobile } from "@src/appV2/redesign/AppLayout/useResponsive";
import { useIsRedesignEnabled } from "@src/appV2/redesign/hooks/useIsRedesignEnabled";

import { ResetPasswordViewLegacy } from "./ResetPasswordViewLegacy";
import { ResetPasswordViewRedesigned } from "./ResetPasswordViewRedesigned";

export interface ResetPasswordViewProps {
  step: "confirm" | "success";
  email: string;
  newPassword: string;
  confirmPassword: string;
  isSubmitting: boolean;
  error: string | undefined;
  hasActiveSession: boolean;
  onNewPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  onSubmit: (formEvent: React.FormEvent) => void;
  onGoToLogin: () => void;
}

export function ResetPasswordView(props: ResetPasswordViewProps) {
  const isRedesignEnabled = useIsRedesignEnabled();
  const isMobileViewport = useIsMobile();

  if (isMobileViewport || isRedesignEnabled) {
    return <ResetPasswordViewRedesigned {...props} />;
  }

  return <ResetPasswordViewLegacy {...props} />;
}
